import { Component, OnInit } from '@angular/core';
import {CardImageInfo} from "../models/card_imagesmaster";
import {CardImagesService} from "../services/card_images.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-cardview',
  templateUrl: './card_imagesview.component.html',
})
export class CardImagesviewComponent implements OnInit {

    cardimagesinfo:CardImageInfo;
    constructor(
        private cardImageService:CardImagesService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getCardImageInfo()
    }
    getCardImageInfo=function () {
        console.log(this.activatedRoute)
        this.activatedRoute.params.subscribe(params => {
            let card_images_id = params['id'];
            console.log("CardImageId======>",card_images_id); // Print the parameter to the console.
            this.cardImageService.getCardImageInfo(card_images_id).then(data => {
                console.log("CardImagesInfo=======>",data['data']);
                this.cardimagesinfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_imagesmaster/card_imagesview/card_imagesview.component.ts